import React, { useContext, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import SignoutButton from "../../components/SignoutButton";
import { UserContext } from "../../context/Context";
import AdminNav from "./AdminNav";

const Admin = () => {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      navigate("/admin/login");
    }

    return () => {};
  }, []);

  if (user) {
    return user.roles.includes("admin") ? (
      <div>
        <Outlet />
      </div>
    ) : (
      <>
        <h1>You do not have access, please sign in as admin.</h1>
        <SignoutButton />
      </>
    );
  }

  return <>Something went wrong.</>;
};

export default Admin;
